import WHowAnalyse from './WHowAnalyse'

export default WHowAnalyse
